import React from "react";
import CommonDropDown from "../../Common/DropDown/CommonDropDown";

type DisplayValue = {
  display: string;
  value: string;
};

type Props = {
  label: string;
  displayValues?: DisplayValue[];
  selected?: string;
  onChange?: (id: string) => void;
  style?: React.CSSProperties;
};
const ToolsContentComboBox = ({
  label,
  displayValues = [],
  selected,
  onChange = () => {},
  style = {},
}: Props) => {
  const onValueChanged = (id: string) => {
    onChange(id);
  };

  const dropDownDisplayValues = displayValues.map((dv) => ({
    display: dv.display,
    value: dv.value,
    disabled: false,
  }));

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 5,
        ...style,
      }}
    >
      <label
        style={{
          margin: "auto 0",
          fontSize: 13,
        }}
      >
        {label}
      </label>
      <CommonDropDown
        id={`tools-selector-${label}`}
        style={{
          width: "233px",
          height: 34,
          background: "#FFFFFF",
          borderColor: "#414042",
        }}
        onChange={(value) => onValueChanged(value)}
        value={selected? selected : ""}
        dropDownDisplayValues={dropDownDisplayValues}
      />
    </div>
  );
};

export default ToolsContentComboBox;
